import type { ActivityRow } from '../../core';
import { AutomationBlockerRow } from './AutomationBlockerRow';
import { QueueChangeRow } from './QueueChangeRow';
import { StatusChangeRow } from './StatusChangeRow';

export const renderDocumentRow = (row: ActivityRow) => {
  switch (row.kind) {
    case 'status':
      return (
        <StatusChangeRow previousValue={row.previousValue} value={row.value} />
      );
    case 'queue':
      return (
        <QueueChangeRow
          previousQueueId={row.previousQueueId}
          queueId={row.queueId}
          previousQueueName={row.previousQueueName}
          queueName={row.queueName}
        />
      );
    case 'automationBlocker':
      return (
        <AutomationBlockerRow
          blockerType={row.blockerType}
          fields={row.fields}
        />
      );
    default:
      return null;
  }
};
